<template>
  <div>
    <h2 class="subtitle">{{ $t("settings.storeAddress") }}</h2>

    <p>
      {{
        `${storeBeingManaged.address.street}, ${
          storeBeingManaged.address.number
        }, ${storeBeingManaged.address.neighborhood}, ${
          storeBeingManaged.address.city
        }, ${storeBeingManaged.address.state}, ${$t("common.zipcode")}: ${
          storeBeingManaged.address.zipcode
        }`
      }}
      <a
        :href="
          `https://www.google.com/maps/search/?api=1&query=${
            storeBeingManaged.address.geolocation.coordinates[1]
          },${storeBeingManaged.address.geolocation.coordinates[0]}`
        "
        target="_blank"
        @click.stop
        class="external-link"
      >
        <b-icon icon="external-link-square-alt"></b-icon>
      </a>
    </p>
  </div>
</template>

<script>
export default {
  props: ["storeBeingManaged"]
};
</script>

<style scoped>
.external-link {
  position: relative;
  top: 5px;
  left: 5px;
}
</style>
